<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="bondMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.保证金金额')}}<template slot="title">{{$t('询价记录.保证金金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.bondMoney" disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="payType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.付款方式')}}<template slot="title">{{$t('询价记录.付款方式')}}</template>
          </a-tooltip>
        </span>
        <a-select style="width: 100%" v-model="form.payType" :placeholder="$t('通用.输入.请选择')+$t('询价记录.付款方式')">
<!--          <a-select-option  :value="1" :key="1">支付宝</a-select-option>-->
          <a-select-option  :value="2" :key="2">微信</a-select-option>
        </a-select>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('支付')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import {
  payBzj
} from '@/api/activityXunjia/activityXunjia'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor";
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
       formTitle: '',
       form:{
         activityId:null,
         goodsId:null,
         bondMoney:null,
         payType:null
       },
      submitLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 1增加,2修改
      // formType: 1,
      open: false,
      rules: {
        payType: [
          { required: true, message: this.$t('询价记录.付款方式')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },

    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.form.activityId = row.activityId
      this.form.goodsId = row.goodsId
      this.form.bondMoney = row.bondMoney
      this.open = true
      this.formTitle = '缴纳保证金'
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        activityId:null,
        goodsId:null,
        bondMoney:null,
        payType:null
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '成功';
          payBzj(this.form).then(response => {
            this.$message.success(
              message,
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      });
    },
  }
}
</script>
